// src/utils/dniUtils.ts
var DNI_LETTERS = "TRWAGMYFPDXBNJZSQVHLCKE";
function validateSpanishId(id) {
  if (!id) {
    return { valid: false, error: "ID is required" };
  }
  const normalized = id.toUpperCase().replace(/[\s-]/g, "");
  if (/^\d{8}[A-Z]$/.test(normalized)) {
    const num = parseInt(normalized.slice(0, 8), 10);
    const letter = normalized[8];
    const expectedLetter = DNI_LETTERS[num % 23];
    if (letter === expectedLetter) {
      return {
        valid: true,
        type: "DNI",
        normalized
      };
    }
    return {
      valid: false,
      type: "DNI",
      error: `Invalid check letter. Expected ${expectedLetter}, got ${letter}`
    };
  }
  if (/^[XYZ]\d{7}[A-Z]$/.test(normalized)) {
    const prefixMap = { X: "0", Y: "1", Z: "2" };
    const numStr = prefixMap[normalized[0]] + normalized.slice(1, 8);
    const num = parseInt(numStr, 10);
    const letter = normalized[8];
    const expectedLetter = DNI_LETTERS[num % 23];
    if (letter === expectedLetter) {
      return {
        valid: true,
        type: "NIE",
        normalized
      };
    }
    return {
      valid: false,
      type: "NIE",
      error: `Invalid check letter. Expected ${expectedLetter}, got ${letter}`
    };
  }
  return {
    valid: false,
    error: "Invalid format. Expected DNI (8 digits + letter) or NIE (X/Y/Z + 7 digits + letter)"
  };
}
function isDniFormat(id) {
  const normalized = id.toUpperCase().replace(/[\s-]/g, "");
  return /^\d{8}[A-Z]$/.test(normalized);
}
function isNieFormat(id) {
  const normalized = id.toUpperCase().replace(/[\s-]/g, "");
  return /^[XYZ]\d{7}[A-Z]$/.test(normalized);
}
function calculateDniLetter(dniNumber) {
  const num = parseInt(dniNumber.replace(/\D/g, ""), 10);
  return DNI_LETTERS[num % 23];
}
function normalizeDni(id) {
  const result = validateSpanishId(id);
  return result.valid ? result.normalized : null;
}
function formatDniForDisplay(id) {
  const normalized = id.toUpperCase().replace(/[\s-]/g, "");
  if (normalized.length === 9) {
    return `${normalized.slice(0, 8)}-${normalized[8]}`;
  }
  return normalized;
}

export {
  validateSpanishId,
  isDniFormat,
  isNieFormat,
  calculateDniLetter,
  normalizeDni,
  formatDniForDisplay
};
